import { CDN_URL } from './index'

export default [
  {
    num: 12,
    icon: `${CDN_URL}/offlinePay/goods/wz/1.png?v=1`,
    price: 12,
    name: '12钻石',
    id: 'daibi.wxgfios4.cq12'
  },
  {
    num: 30,
    icon: `${CDN_URL}/offlinePay/goods/wz/2.png?v=1`,
    price: 30,
    name: '30钻石',
    id: 'daibi.wxgfios4.cq30'
  },
  {
    num: 50,
    icon: `${CDN_URL}/offlinePay/goods/wz/3.png?v=1`,
    price: 50,
    name: '50钻石',
    id: 'daibi.wxgfios4.cq50'
  },
  {
    num: 98,
    icon: `${CDN_URL}/offlinePay/goods/wz/4.png?v=1`,
    price: 98,
    name: '98钻石',
    id: 'daibi.wxgfios4.cq98'
  },
  {
    num: 128,
    icon: `${CDN_URL}/offlinePay/goods/wz/5.png?v=1`,
    price: 128,
    name: '128钻石',
    id: 'daibi.wxgfios4.cq128'
  },
  {
    num: 198,
    icon: `${CDN_URL}/offlinePay/goods/wz/6.png?v=1`,
    price: 198,
    name: '198钻石',
    id: 'daibi.wxgfios4.cq198'
  },
  {
    num: 328,
    icon: `${CDN_URL}/offlinePay/goods/wz/7.png?v=1`,
    price: 328,
    name: '328钻石',
    id: 'daibi.wxgfios4.cq328'
  },
  {
    num: 588,
    icon: `${CDN_URL}/offlinePay/goods/wz/8.png?v=1`,
    price: 588,
    name: '588钻石',
    id: 'daibi.wxgfios4.cq588'
  },
  {
    num: 648,
    icon: `${CDN_URL}/offlinePay/goods/wz/9.png?v=1`,
    price: 648,
    name: '648钻石',
    id: 'daibi.wxgfios4.cq648'
  }
]
